export default __webpack_public_path__ + "static/media/am.4c06014a.svg";